import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.page.html',
  styleUrls: ['./meeting.page.scss'],
})
export class MeetingPage implements OnInit {
  @ViewChild('meetingContent') meetingContent: IonContent;
  public buttons = [
    {
      name: 'Servicios',
      value: 'services',
    },
    {
      name: 'Bloqueo de horarios',
      value: 'blockTurns',
    },
    {
      name: 'Horarios',
      value: 'schedule',
    },
  ];

  public segmentValue = 'services';
  public savedForm = undefined;
  public editing = undefined;
  public formSchedules: any[] = [1];

  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private formSv: FormServices,
    private trSv: TranslateService,
    private fileSv: FileService
  ) {}

  ngOnInit() {}

  setSegment(ev) {
    this.savedForm = undefined;
    this.segmentValue = ev;
  }

  async setForm(data) {
    try {
      if (data.action === 'edit' || data.action === 'copy') {
        if (data.action === 'copy') {
          this.fileSv.copyObs.emit();
        }
        this.savedForm = data.product;
        if (data.action === 'edit') {
          this.editing = this.savedForm.id;
        } else {
          this.editing = undefined;
        }

        if (this.segmentValue === 'schedule') {
          if (typeof this.savedForm.day === 'string') {
            this.savedForm.day = this.savedForm.day.split(',');
          }
        }

        if (this.savedForm?.categories && this.savedForm?.categories[0]?.id) {
          this.savedForm.categories = this.savedForm.categories.map(
            (item) => item.id
          );
        }

        if (this.savedForm?.operators && this.savedForm?.operators[0]?.id) {
          this.savedForm.operators = this.savedForm.operators.map(
            (item) => item.id
          );
        }

        this.savedForm.isActive = this.savedForm.isActive ? true : false;
      } else if (data.action === 'delete') {
        const name = this.buttons.find(
          (item) => item.value === this.segmentValue
        ).name;
        const item = data.product;
        const trD = this.trSv.instant('DESEAS_ELIMINAR_EL');
        const trOf = this.trSv.instant('DE');
        const { role } = await this.uiSv.presentAlert(
          `${trD} ${item.name} ${trOf} ${name}`
        );
        if (role === 'accept') {
          await this.httpSv.deleteItem({ id: item.id }, this.segmentValue);
          this.formSv.deleteListProductSrc.next('reloadListProduct');
          this.formSv.clearFormSrc.next();
        }
      } else {
        this.editing = undefined;
      }
    } catch (err) {
      console.error(err);
    }
  }
  async send(ev: FormData) {
    try {
      await this.uiSv.showLoading();
      this.editing && ev.set('id', String(this.editing));
      await this.httpSv.itemAction(
        ev,
        this.segmentValue,
        this.editing ? 'update' : 'store'
      );
      this.formSv.deleteListProductSrc.next('reloadListProduct');
      this.formSv.clearFormSrc.next();
      this.savedForm = undefined;
      this.editing = undefined;
      await this.uiSv.loading.dismiss();
      await this.meetingContent.scrollToTop(400);
    } catch (err) {
      await this.uiSv.loading.dismiss();
      console.error(err);
    }
  }

  // setSchedule(ev: FormData){
  //   const obj = {};
  //   ev.forEach((item, key) => {
  //     obj[key] = item;
  //   });
  //   this._schedule.push(obj);
  //   this._scheduleCounter++;
  //   if(this._scheduleCounter === this.formSchedules.length){
  //     const data = new FormData();
  //     data.set('data', JSON.stringify(this._schedule));
  //     this.send(data);
  //   }
  // }

  // addSchedule(){
  //   this.formSchedules.push(1);
  // }

  // saveSchedule(){
  //   this._schedule = [];
  //   this._scheduleCounter = 0;
  //   this.formSv.getDataSrc.next();
  // }
}
